<template>
    <div>
        <b-breadcrumb :items="crumbs"/>
    </div>
</template>

<script type="text/javascript">
    export default {
      props: {
        crumbString: ''
      },

      computed: {
        crumbs () {
          let crumbRoutes = {
            'What We Do': '/what-we-do',
            'Products': '/products',
            'Graphic Panels': '/products/graphic-panels',
            'Mountings': '/products/mountings',
            'Creative Services': '/creative-services',
            'Graphic Design': '/graphic-design',
            'View Our Work': '/view-our-work',
            'Create an Estimate': '/create-an-estimate',
            'Contact Us': '/contact-us',
            'FTP Instructions': '/ftp-instructions',
            'FTP Uploads': '/ftp-uploads'
          }
          let crumbs = this.crumbString.split(',').map((val) => {
            return {text: val, href: crumbRoutes[val]}
          })

          // Add home to beginning of breadcrumbs
          crumbs.unshift({
            text: 'Home',
            href: '/home'
          })

          return crumbs
        }
      }
    }
</script>

<style lang="scss">
    @import '../assets/css/breadcrumb.scss';
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue